import ContactMail from '@/generated/controls/contact/ContactMail.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: ContactMail
})
